import { CountryCode, Pmc } from 'types/generatedSchemaTypes';
import { WebAndMobileRegion } from 'types/MapTypes';
import { create } from 'zustand';

type ByMemberGroupSearchParams = {
  memberGroupName: string;
  countryCode: CountryCode;
  city: City;
};

export type City = 'Turku';

type CityParking = {
  strongAuthFlow: boolean;
  strongAuthCompleted: boolean;
  selectedPmc: Pmc | null;
  searchTerm: string;
  byMemberGroupSearchParams: ByMemberGroupSearchParams;
  previousCoordinates: WebAndMobileRegion | null;
};

type CityParkingActions = {
  setStrongAuthFlow: (strongAuthFlow: boolean) => void;
  setStrongAuthCompleted: (strongAuthCompleted: boolean) => void;
  setSelectedPmc: (selectedPmc: Pmc | null) => void;
  setSearchTerm: (searchTerm: string) => void;
  setPreviousCoordinates: (previousCoordinates: WebAndMobileRegion) => void;
  resetState: () => void;
};

export const useCityParkingStore = create<CityParking & CityParkingActions>()(
  (set) => ({
    strongAuthFlow: false,
    strongAuthCompleted: false,
    selectedPmc: null,
    searchTerm: '',
    byMemberGroupSearchParams: {
      memberGroupName: 'TKU Asukaspysäköintialue',
      countryCode: 'FI',
      city: 'Turku',
    },
    previousCoordinates: null,
    setStrongAuthFlow: (strongAuthFlow) => set({ strongAuthFlow }),
    setStrongAuthCompleted: (strongAuthCompleted) =>
      set({ strongAuthCompleted }),
    setSelectedPmc: (selectedPmc) => set({ selectedPmc }),
    setSearchTerm: (searchTerm) => set({ searchTerm }),
    setPreviousCoordinates: (previousCoordinates) =>
      set({ previousCoordinates }),
    resetState: () =>
      set({
        selectedPmc: null,
        searchTerm: '',
        strongAuthCompleted: false,
        strongAuthFlow: false,
        byMemberGroupSearchParams: {
          memberGroupName: 'TKU Asukaspysäköintialue',
          countryCode: 'FI',
          city: 'Turku',
        },
        previousCoordinates: null,
      }),
  })
);
